export default {"src":"/_next/static/media/shield-alert.e5cd8545.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};